import { jsxs as e, jsx as t } from "react/jsx-runtime";
import o from "@mui/icons-material/ChevronRight";
import { useTheme as r, Skeleton as i } from "@mui/joy";
import l from "@mui/joy/Stack";
import n from "@mui/joy/Typography";
import { DialogTitle as a, IconContainer as p } from "./styled.js";
import { CopyText as m } from "../../../common/components/CopyText/CopyText.js";
const d = { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }, s = ({ icon: s2, subtitle: c, title: h, copy: x, children: u, loading: f, titleColor: g = "neutral.800", sx: v, hideChevron: w = false }) => {
  const y = r();
  return e(a, { sx: v, children: [t(p, { children: s2 }), e(l, { direction: "row", alignItems: "center", gap: 1, flex: 1, sx: { maxWidth: "100%" }, children: [t(n, { level: "title-md", fontWeight: 600, textColor: y.palette.isDarkMode ? y.palette.neutral[600] : y.palette.neutral[500], sx: { whiteSpace: "nowrap" }, children: c }), !w && t(o, { sx: { width: 16, height: 16, color: y.palette.isDarkMode ? y.palette.neutral[600] : y.palette.neutral[500] } }), t(n, { level: "title-md", textColor: g, sx: d, children: t(i, { variant: "text", loading: !!f, level: "title-lg", sx: { width: "392px", borderRadius: "24px" }, children: !f && h }) }), x && t(m, { value: x }), u] })] });
};
export {
  s as DialogTitleBasic,
  d as titleStyles
};
//# sourceMappingURL=DialogTitleBasic.js.map
